import { Progress } from "@mantine/core";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import routeNames from "../../routes/routeNames";
import Button from "../Button";
import "./styles.css";

const Index = () => {
  const navigate = useNavigate();
  return (
    <div
      className="profile-com shadow"
      onClick={() => navigate(routeNames.employer.myProfile)}
    >
      <h5 className="text-dark">
        Help Candidates Learn More About your Company
      </h5>
      <Progress value={25} label="25%" size={25} radius="xl" color={"red"} />
      <p className="mb-0">Tasks to completion: </p>
      <ul>
        <li>Complete Profile</li>
        <li>Complete Company Location</li>
        <li>Complete About Details</li>
        <li>Complete Corporate Culture</li>
      </ul>
      <Button
        title="Complete Your Profile"
        primary={true}
        width="100%"
      />
    </div>
  );
};
export default withTranslation()(Index);
